module.exports = __webpack_public_path__ + "img/conTeacher.09d14cd6.png";